export const CLIENT_ID_COOKIE = 'client_id'
export const DATAFILE_CACHE_KEY = 'datafile'
